import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import type { WidgetFlowT } from 'lib-shared-legacy-types';
import { ampli } from 'lib-shared-tracking';

import styles from './chatWidgetDotsMenu.module.scss';

type ChatWidgetDotsMenuProps = {
  deleteWidget: (widget: WidgetFlowT) => void;
  duplicateWidget: (widget: WidgetFlowT) => void;
  goToChatFlow: (flowId: string) => void;
  goToAuditLogs: (widgetId: string) => void;
  goToWidgetSettings: (widgetId: string) => void;
  renameWidget: (widget: WidgetFlowT) => void;
  widget: WidgetFlowT;
};

export const ChatWidgetDotsMenu = (props: ChatWidgetDotsMenuProps) => {
  const hasChannelSetupAccess = useHasAccess(
    'settings.integration.channel.setup',
    { fallbackRole: 'admin' },
  );
  const hasFlowReadAccess = useHasAccess('settings.flow:r');
  const hasFlowWriteAccess = useHasAccess('settings.flow:w');

  const goToChatFlow = (): void => {
    const { goToChatFlow, widget } = props;
    ampli.chatOptionsMenuOptionFlowClicked();
    goToChatFlow(widget.flows[0].id);
  };

  const goToWidgetSettings = (): void => {
    const { goToWidgetSettings, widget } = props;
    ampli.chatOptionsMenuOptionSetupClicked();
    goToWidgetSettings(widget.id);
  };

  const goToAuditLogs = (): void => {
    const { goToAuditLogs, widget } = props;
    const {
      flows: [{ id }],
    } = widget;
    ampli.chatFlowOptionsMenuOptionAuditLogClicked();
    goToAuditLogs(id);
  };

  const renameWidget = (): void => {
    const { renameWidget, widget } = props;
    ampli.chatOptionsMenuOptionRenameClicked();
    renameWidget(widget);
  };

  const duplicateWidget = (): void => {
    const { duplicateWidget, widget } = props;
    ampli.chatOptionsMenuOptionDuplicateClicked();
    duplicateWidget(widget);
  };

  const deleteWidget = (): void => {
    const { deleteWidget, widget } = props;
    ampli.chatOptionsMenuOptionDeleteClicked();
    deleteWidget(widget);
  };

  const onToggleMenu = (isOpen: boolean): void => {
    if (isOpen) {
      ampli.chatOptionsMenuOpened();
    }
  };

  return (
    <DropdownButton
      className={styles.dropDownButton}
      icon="dots-h"
      fixed
      buttonProps={{ variant: 'tertiary' }}
      onToggle={onToggleMenu}
      noArrow
      dropdown={
        <ButtonList>
          {hasFlowReadAccess && (
            <>
              <ButtonList.Item onClick={goToChatFlow}>
                Edit flow
              </ButtonList.Item>
              {hasChannelSetupAccess && hasFlowWriteAccess && (
                <ButtonList.Item onClick={duplicateWidget}>
                  Duplicate
                </ButtonList.Item>
              )}
            </>
          )}
          <ButtonList.Item onClick={goToWidgetSettings}>Setup</ButtonList.Item>

          {hasFlowReadAccess && (
            <>
              {hasFlowWriteAccess && (
                <ButtonList.Item onClick={renameWidget}>Rename</ButtonList.Item>
              )}
              <ButtonList.Item onClick={goToAuditLogs}>
                See audit log
              </ButtonList.Item>
            </>
          )}

          {hasChannelSetupAccess && (
            <>
              <ButtonList.Divider />
              <ButtonList.Item onClick={deleteWidget}>Delete</ButtonList.Item>
            </>
          )}
        </ButtonList>
      }
    />
  );
};
